export * from './src/terms-of-use.component';
export * from './src/terms-of-use-dialog.service';
